var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6666 7.75867C17.9595 7.46578 18.4343 7.46578 18.7272 7.75867L23.0832 12.1147C23.2239 12.2553 23.3029 12.4461 23.3029 12.645C23.3029 12.8439 23.2239 13.0347 23.0832 13.1753L18.7272 17.5313C18.4343 17.8242 17.9595 17.8242 17.6666 17.5313C17.3737 17.2384 17.3737 16.7636 17.6666 16.4707L21.4923 12.645L17.6666 8.81933C17.3737 8.52644 17.3737 8.05157 17.6666 7.75867Z",
    fill: "#929B9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.297 12.645C10.297 12.2308 10.6328 11.895 11.047 11.895H21.166C21.5802 11.895 21.916 12.2308 21.916 12.645C21.916 13.0592 21.5802 13.395 21.166 13.395H11.047C10.6328 13.395 10.297 13.0592 10.297 12.645Z",
    fill: "#929B9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59998 4C4.59998 3.58579 4.93576 3.25 5.34998 3.25H14.212C14.6262 3.25 14.962 3.58579 14.962 4C14.962 4.41421 14.6262 4.75 14.212 4.75H6.09998V20.54H14.212C14.6262 20.54 14.962 20.8758 14.962 21.29C14.962 21.7042 14.6262 22.04 14.212 22.04H5.34998C4.93576 22.04 4.59998 21.7042 4.59998 21.29V4Z",
    fill: "#929B9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.76fdc8ae7fc2101639870979c0e2bbb6.svg";
export { ForwardRef as ReactComponent };